import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    standalone: false,
    selector: 'wiz-component-nav-sidebar',
    templateUrl: './view.html',
    styleUrls: []
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        if (link === '/') {
            return location.pathname === '/' || location.pathname === '/dashboard';
        }
        return location.pathname.indexOf(link) === 0;
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-medium text-red-600";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-red-600";
    }

    public logout(event: Event) {
        event.preventDefault();
        if (this.service && this.service.auth) this.service.auth.clearLocalSession();
        window.location.href = '/auth/logout';
    }
}

export default ComponentNavSidebarComponent;